<template>
  <div class="c-profile-view-tile tile">
    <div class="c-profile-view-tile__info w-100">
      <div class="c-profile-view-tile__info__avatar">
        <div class="c-profile-view-tile__info__avatar-cnt">
          <Avatar />
          <input
            type="file"
            accept="image/*"
            ref="fileInput"
            hidden
            style="display: none"
            @change="onFileAdded"
          />
        </div>
        <div class="c-profile-view-tile__avatar__circle">
          <svg height="100" width="100" style="transform: rotate(70deg)">
            <circle
              cx="50%"
              cy="50%"
              r="47"
              stroke-dasharray="250"
              :stroke="primary"
              stroke-dashoffset="0"
              stroke-width="3"
              fill="none"
            />
          </svg>
          <div
            @click="openInputFile"
            class="c-profile-view-tile__avatar__icon btn-primary"
            v-html="iconPhoto"
          ></div>
        </div>
      </div>
      <div
        class="c-profile-view-tile__info__details c-profile-view-tile__info__details--first"
      >
        <template>
          <div
            v-if="isTablet || isDesktop"
            class="c-profile-view-tile__info__name"
          >
            {{ getUser.name }}
          </div>
          <div v-if="isMobile" class="c-profile-view-tile__info__name">
            {{ getUser.profile.first_name }} <br />
            {{ getUser.profile.last_name }}
          </div>
        </template>
        <div v-if="isMobile" class="c-profile-view-tile__info__coins">
          {{ $t("Coins") }}: <span>{{ getUser.coins }}</span>
        </div>
        <div class="mt-a w-100" v-if="!isMobile">
          <Progress
            :value="progressValue"
            background="rgba(80, 211, 77, 0.3)"
            color="#50d34d"
            rounded
          />
          <div class="c-profile-view-tile__acc w-100">
            <div class="c-profile-view-tile__acc__level">
              {{ getUser.level }}
            </div>
            <div class="c-profile-view-tile__acc__exp">
              <span class="current-exp">{{ getUser.points }}</span>
              <span v-if="nextLevel.points"
                >/{{ nextLevel.points }} {{ $t("Exp") }}</span
              >
              <span v-else> {{ $t("Exp") }}</span>
            </div>
          </div>
        </div>
      </div>
      <template v-if="isDesktop">
        <div
          class="c-profile-view-tile__info__details  c-profile-view-tile__info__details--level"
        >
          <div class="c-profile-view-tile__info__box" v-html="iconLevel"></div>
          <div class="c-profile-view-tile__box-desc">
            <div class="c-profile-view-tile__box-desc__title">
              {{ $t("Livello") }}
            </div>
            <div class="c-profile-view-tile__level">{{ getUser.level }}</div>
          </div>
        </div>
        <div
          class="c-profile-view-tile__info__details  c-profile-view-tile__info__details--level"
        >
          <div v-if="false">
            <div
              class="c-profile-view-tile__info__box"
              v-html="iconCoins"
            ></div>
            <div class="c-profile-view-tile__box-desc">
              <div class="c-profile-view-tile__box-desc__title">
                {{ $t("Coins") }}
              </div>
              <div class="c-profile-view-tile__coins">{{ getUser.coins }}</div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <template v-if="isMobile">
      <Progress
        :value="progressValue"
        background="rgba(80, 211, 77, 0.3)"
        color="#50d34d"
        rounded
      />
      <div class="c-profile-view-tile__acc w-100">
        <div class="c-profile-view-tile__acc__level">{{ getUser.level }}</div>
        <div class="c-profile-view-tile__acc__exp">
          <span class="current-exp">{{ getUser.points }}</span>
          <span v-if="nextLevel.points"
            >/{{ nextLevel.points }} {{ $t("Exp") }}</span
          >
          <span v-else> {{ $t("Exp") }}</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Progress from "../common/Progress";
import Avatar from "../common/Avatar";

import iconPhoto from "@/assets/svg/new/icon-photo.svg";
import iconLoyalty from "@/assets/svg/new/icon-loyaltyid.svg";
import iconLevel from "@/assets/svg/new/icon-livello.svg";
import iconCoins from "@/assets/svg/new/icon-coins.svg";

import { mapGetters } from "vuex";
import { GlobalService } from "@/common/services/api.service.js";
import { Actions, Mutations } from "@/store/global/global.types.js";

const toBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

export default {
  name: "ProfileViewTile",
  components: {
    Progress,
    Avatar
  },
  data() {
    return { iconPhoto, iconLoyalty, iconLevel, iconCoins };
  },
  computed: {
    ...mapGetters([
      "getUser",
      "isMobile",
      "campaign",
      "nextLevel",
      "isDesktop",
      "isTablet"
    ]),
    primary() {
      return this.campaign.css_settings.primary;
    },
    progressValue() {
      if (this.nextLevel.noMoreLevels) {
        return 100;
      }
      return (this.getUser.points / this.nextLevel.points) * 100;
    }
  },
  methods: {
    openInputFile() {
      this.$refs.fileInput.click();
    },
    async onFileAdded(e) {
      const avatar = await toBase64(e.target.files[0]);
      this.$store.commit(Mutations.SHOW_SPINNER);
      await GlobalService.uploadAvatar({ avatar });
      await this.$store.dispatch(Actions.GET_USER_PROFILE);
      this.$store.commit(Mutations.HIDE_SPINNER);
    }
  }
};
</script>
<style lang="scss">
body {
  box-sizing: border-box;
}
</style>
<style lang="scss" scoped>
.c-profile-view-tile {
  padding: 25px 20px 15px 30px;
  position: relative;

  @media (min-width: 992px) {
    padding: 60px 60px;
  }
}

.c-profile-view-tile__info {
  display: flex;
  margin-bottom: 40px;
  min-height: 105px;
  @media (min-width: 992px) {
    margin-bottom: 0px;
  }
}

.c-profile-view-tile__info__avatar {
  position: relative;
  width: 80px;
  height: 80px;
}

.c-profile-view-tile__info__avatar-cnt {
  width: 80px;
  height: 80px;

  @media (min-width: 767px) {
    width: 100px;
    height: 100px;
  }
}

.c-profile-view-tile__avatar__circle {
  position: absolute;
  top: -10px;
  left: -10px;

  @media (min-width: 767px) {
    svg {
      height: 120px;
      width: 120px;
    }
    circle {
      r: 57;
      stroke-dasharray: 300;
    }
  }
}

.c-profile-view-tile__avatar__icon {
  height: 30px;
  width: 30px;
  border-radius: 50%;
  position: absolute;
  right: 2px;
  bottom: 13px;
  z-index: 2;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 2px 3px 8px 0 rgba(0, 0, 0, 0.1);

  @media (min-width: 767px) {
    width: 40px;
    height: 40px;
    right: -3px;
    bottom: 9px;
  }
}

.c-profile-view-tile__info__details {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  margin-left: 30px;

  @media (min-width: 767px) {
    margin-left: 50px;
    width: 100%;
    max-width: 300px;
  }

  @media (min-width: 992px) {
    margin-left: 50px;
    position: relative;
    width: calc((100% - 150px) / 3);
    justify-content: center;
    &--first {
      padding-right: 30px;
      justify-content: space-between;

      &::after {
        content: "";
        position: absolute;
        top: -50px;
        right: -11px;
        width: 2px;
        height: 185px;
        background-color: rgba(205, 208, 227, 0.3);
      }
    }
  }
}

.c-profile-view-tile__info__name {
  font-weight: bold;
  font-size: 22px;
  line-height: 35px;
  min-height: 22px;
}

.c-profile-view-tile__info__coins {
  color: #8a8497;

  span {
    color: #ffce00;
    font-weight: bold;
  }
}

.c-profile-view-tile__acc {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  @media (min-width: 767px) {
    margin-top: 5px;
  }
}

.c-profile-view-tile__acc__exp {
  color: #8a8497;

  .current-exp {
    font-weight: bold;
    color: #000;
  }
}

.c-profile-view-tile__iconLoyalty {
  position: absolute;
  right: 15px;
  top: 15px;
}

.c-profile-view-tile__info__loyalyty {
  margin-bottom: 10px;
  color: #8a8497;
}

.c-profile-view-tile__id {
  color: #000;
}

.c-profile-view-tile__info__box {
  width: 80px;
  height: 80px;
  border-radius: 10px;
}

.c-profile-view-tile__info__details--level {
  flex-direction: row;
  justify-content: start;
  align-items: center;
}

.c-profile-view-tile__level,
.c-profile-view-tile__coins {
  font-weight: bold;
  font-size: 30px;
  min-height: 30px;
}

.c-profile-view-tile__box-desc {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 15px;
}

.c-profile-view-tile__box-desc__title {
  color: #160931;
  opacity: 0.5;
}

.c-profile-view-tile__coins {
  color: #ffce00;
}

.c-profile-view-tile__acc__level {
  font-weight: bold;
}
</style>
